import {
    CreateSubscriptionArgs,
    DeleteSubscriptionArgs,
} from '~shared/schema/wiki/actions/subscriptions';

import toaster from '~ui/utils/toaster';

import {createThunk, makeThunkErrorHandler} from '~ui/store/utils';
import {i18n} from '~ui/components/AsideNavigation/i18n';

export const createSubscription = createThunk(
    'subscriptions/create',
    (data: CreateSubscriptionArgs, thunkAPI) => {
        const {sdk} = thunkAPI.extra;

        return sdk.wiki
            .createSubscription(data)
            .then((res) => {
                toaster.createToast({
                    type: 'success',
                    name: 'subscriptions-create-success',
                    title: i18n('subscriptions-create-success'),
                });

                return res;
            })
            .catch(
                makeThunkErrorHandler({
                    name: 'subscriptions-create-error',
                    title: i18n('subscriptions-create-error'),
                }),
            );
    },
);

export const deleteSubscriptions = createThunk(
    'subscriptions/delete',
    (data: DeleteSubscriptionArgs, thunkAPI) => {
        const {sdk} = thunkAPI.extra;

        return sdk.wiki
            .deleteSubscription(data)
            .then((res) => {
                toaster.createToast({
                    type: 'success',
                    name: 'subscriptions-delete-success',
                    title: i18n('subscriptions-delete-success'),
                });

                return res;
            })
            .catch(
                makeThunkErrorHandler({
                    name: 'subscriptions-delete-error',
                    title: i18n('subscriptions-delete-error'),
                }),
            );
    },
);
